<custom-select          #daySelect 
                        [values]        =   "values"
                        title_multiple  =   "custom.day.title"
                        autoSelectFirst =   "true"
                        (change)        =   change.emit($event)
                        class           =   "mr-3"></custom-select>